import PropTypes from "prop-types";
export var MoneyPropType = PropTypes.string;